import { Button, Form, Input, Select, Space } from 'antd';
import { FC } from 'react';
import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { PageNodesAllAutocomplete } from '../../../components';
import { PageNodeExtension, PageNodeFormFields, PageNodeFormInputs } from '../../../pageNodes.interfaces';

interface Props extends AppFormProps<typeof PageNodeFormInputs, PageNodeFormFields> {
  isNodeHome: boolean;
  siteId: string;
}

export const PageNodesFormView: FC<Props> = ({
  isNodeHome,
  siteId,
  formName,
  formType,
  formErrors,
  form,
  validationSchema,
  initialValues,
  isFormLoading,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        hidden
        name={ PageNodeFormInputs.SiteId }
      />

      <Form.Item
        label="Повний слаг"
        name={ PageNodeFormInputs.Slug }
        hasFeedback
        extra={ isNodeHome ? 'Слаг головної ноди змінити не можна' : null }
        validateStatus={ defineInputStatus(
          isFormLoading,
          form.getFieldError(PageNodeFormInputs.Slug).length || formErrors?.slug || formErrors?.extension
        ) }
        rules={ validationSchema.slug }
        help={ formErrors?.slug || formErrors?.extension }
        normalize={ (value) => value ? value.toLowerCase() : value }
      >
        <Input
          disabled={ isFormLoading }
          allowClear
          readOnly={ isNodeHome }
          addonAfter={
            <Form.Item
              name={ PageNodeFormInputs.Extension }
              hasFeedback
              noStyle
              validateStatus={ defineInputStatus(isFormLoading, formErrors?.extension) || '' }
              rules={ validationSchema.extension }
            >
              <Select placeholder="Розширення" allowClear className="page-node-extensions-select">
                <Select.Option value={ PageNodeExtension.HTML }>.{ PageNodeExtension.HTML }</Select.Option>
                <Select.Option value={ PageNodeExtension.HTM }>.{ PageNodeExtension.HTM }</Select.Option>
                <Select.Option value={ PageNodeExtension.PHP }>.{ PageNodeExtension.PHP }</Select.Option>
              </Select>
            </Form.Item>
          }
        />
      </Form.Item>

      <Form.Item
        label="Батьківська нода"
        name={ PageNodeFormInputs.ParentNodeId }
        hasFeedback
        required
        help={ formErrors?.parentNodeId }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.parentNodeId) }
        rules={ validationSchema.parentNodeId }
        extra={ isNodeHome && 'Головна нода не має батьківської' }
      >
        <PageNodesAllAutocomplete disabled={ isNodeHome || isFormLoading } siteId={ siteId }/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
